export enum DATA_QA {
  ROOT = 'dnc-import-upload-step',
  CONTINUE = 'dnc-import-upload-step__continue',
  FILE_INPUT = 'dnc-csv-upload__file-input',
  LOADING = 'dnc-import-upload-step__loading',
  UPLOAD_ERROR = 'dnc-csv-upload__error-message',
}
